import axios from 'axios';

import cfac22 from '../cfac22';

export default function getRatings(uId, establishmentId) {
  return new Promise((resolve, reject) => {
    Promise.resolve().
    then(() => {
      axios.
      get(`${cfac22('API_HOST_V2')}/establishments/${establishmentId}/ratings`, {
        headers: { 'Full-Url': window.location.href }, withCredentials: true
      }).
      then((result) => {
        //console.log("RESULT_RATINGS: ", result);
        resolve(result.data);
      }).
      catch((error) => {
        //console.log("ERROR_RATINGS: ", error);
        return reject(error);
      });
    }).
    catch((error) => {
      reject(error);
    });
  });
}
